export default "__VITE_ASSET__JwM1JwZP__"